var map = {
	"./ico_archive.svg": 6509,
	"./ico_arrow_down.svg": 248,
	"./ico_back.svg": 3058,
	"./ico_barcode.svg": 2815,
	"./ico_calendar.svg": 5230,
	"./ico_check.svg": 211,
	"./ico_close.svg": 5808,
	"./ico_close_circle.svg": 6031,
	"./ico_copy.svg": 362,
	"./ico_corner_bottom_left.svg": 9946,
	"./ico_corner_bottom_right.svg": 3384,
	"./ico_corner_top_left.svg": 8267,
	"./ico_corner_top_right.svg": 9079,
	"./ico_credit_card.svg": 2063,
	"./ico_delete.svg": 9695,
	"./ico_edit_blue.svg": 143,
	"./ico_eye.svg": 4946,
	"./ico_eye_closed.svg": 5514,
	"./ico_fast_forward.svg": 8693,
	"./ico_filter.svg": 1378,
	"./ico_filter_down.svg": 3514,
	"./ico_history.svg": 6525,
	"./ico_home.svg": 7546,
	"./ico_lock.svg": 8107,
	"./ico_logo.svg": 5384,
	"./ico_logout.svg": 7581,
	"./ico_menu.svg": 6389,
	"./ico_move.svg": 6596,
	"./ico_order_active.svg": 7279,
	"./ico_plus.svg": 4554,
	"./ico_plus_white.svg": 5697,
	"./ico_scan.svg": 4013,
	"./ico_search.svg": 6895,
	"./ico_setting.svg": 6026,
	"./ico_sort.svg": 7913,
	"./ico_ticket.svg": 3097,
	"./ico_triagle_down.svg": 6712
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1343;